import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/head2toe.png'


const _hoisted_1 = { class: "hello" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "m-5" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Hello, I am Jay. Nerd by day and Maker of things by night."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Here you can find info about my work experience, job skills and certifications. If you are interested in the stuff I make, visit "),
    /*#__PURE__*/_createElementVNode("a", { href: "http://jaymade.com" }, "JayMade.com")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid",
  src: _imports_0,
  alt: "Hubba Hubba!"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _hoisted_2,
    _hoisted_3
  ]))
}